import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { addService, getServiceById, updateService } from "../../../api/service/serviceapi";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

const AddService = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    slug: "",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [existingImage, setExistingImage] = useState([]);

  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (isEdit) {
      fetchService();
    }
  }, [id]);

  const fetchService = async () => {
    try {
      setLoading(true);
      const res = await getServiceById(id);
      const service = res.data;

      setFormData({
        name: service.name || "",
        description: service.description || "",
        slug: service.slug || "",
      });

  
      setExistingImage(service.icon?.url ? [service.icon.url] : []);
    } catch (error) {
      showToast.error("Failed to load service data");
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Service name is required";
    if (!formData.slug.trim()) newErrors.slug = "Service slug is required";
    if (!formData.description.trim()) newErrors.description = "Description is required";

 
    if (!isEdit && !selectedImage) {
      newErrors.icon = "Service icon is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 
  const handleSubmit = async () => {
    if (!validateForm()) {
      showToast.error("Please fix validation errors");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();

      if (isEdit) {
        data.append("service_id", id);
      }

      data.append("name", formData.name.trim());
      data.append("description", formData.description.trim());
      data.append("slug", formData.slug.trim());

      if (selectedImage) {
        data.append("icon", selectedImage);
      }

      const response = isEdit
        ? await updateService(data)
        : await addService(data);

      if (response?.data?.success) {
        showToast.success(response?.data?.message || "Service updated successfully");
        setTimeout(() => navigate(-1), 1000);
      } 
    } catch (error) {
      showToast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="d-flex align-items-center gap-2 mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}
      >
        <FaArrowLeftLong />
        <h3 className="mb-0">{isEdit ? "Update Service" : "Add Service"}</h3>
      </div>

      <Row className="g-3">
  
        <Col xs={12}>
          <label className="form-label">
            Upload Service Icon {!isEdit && <span className="text-danger">*</span>}
          </label>

          <UploadImage
            onFileSelect={setSelectedImage}
            existingImages={existingImage}
            multiple={false}
          />

          {errors.icon && <small className="text-danger">{errors.icon}</small>}
        </Col>

        <Col md={6}>
          <label className="form-label">
            Service Name <span className="text-danger">*</span>
          </label>
          <FormInput
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
          {errors.name && <small className="text-danger">{errors.name}</small>}
        </Col>

        <Col md={6}>
          <label className="form-label">
            Service Slug <span className="text-danger">*</span>
          </label>
          <FormInput
            value={formData.slug}
            onChange={(e) => handleChange("slug", e.target.value)}
          />
          {errors.slug && <small className="text-danger">{errors.slug}</small>}
        </Col>

  
        <Col xs={12}>
          <label className="form-label">
            Service Description <span className="text-danger">*</span>
          </label>
          <FormInput
            type="textarea"
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />
          {errors.description && (
            <small className="text-danger">{errors.description}</small>
          )}
        </Col>

        <Col xs={12}>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : isEdit ? "Update Service" : "Add Service"}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default AddService;
